import React, { ReactElement, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = (props: { public?: boolean }): ReactElement => {
  const [result, setIsResult] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    if (props.public) {
      setIsResult(true);
    }
  }, []);

  return (
    <div className="tm__polls">
      <div className="tm__polls-body text-center">
        <div className="d-flex flex-column align-items-center">
          <i className="bi bi-exclamation-circle fs-1 text-primary"></i>
          <span>{t("POLLS_NOT_ACTIVE")}</span>
        </div>
      </div>
      {result && (
        <div className="tm__polls-footer tm__polls-footer-divider d-flex justify-content-center">
          <Link className="btn btn-primary btn-small fw-bold" to="/">
            Go Home
          </Link>
        </div>
      )}
    </div>
  );
};

export default NotFound;
